import {
    AnnualPolicyInfo,
    ICustomerPortalService,
    PaymentCard,
    PolicyProperty,
    ProductsEnum,
    resourcesHelper,
    Types
} from "@falcon/services";
import * as React from "react";
import {Link} from "react-router-dom";
import {getAmountToDisplay} from "../../CommonFunctions";
import {lazyInject} from "@athena-portal/core";

interface IProps {
    amount: number;
    multiProductPage?: boolean;
    policyNumber: string;
    product: ProductsEnum;
}

interface IState {
    reuseCard?: boolean
}

export class OutstandingPaymentBanner extends React.Component<IProps, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: any) {
        super(props);
        this.state = {}
    }

    public componentDidMount(): void {
        this.customerPortalService.getPolicyPropertyByPropertyKey(this.props.policyNumber!, "mainAnnualPaymentCard").subscribe(
            (property: PolicyProperty) => {
                this.customerPortalService.getAnnualPolicyInfo(this.props.policyNumber!).subscribe((annualPolicyInfo: AnnualPolicyInfo) => {
                    if (property && annualPolicyInfo && annualPolicyInfo.paymentCards) {
                        const mainCards: PaymentCard[] = annualPolicyInfo.paymentCards.filter(c => c.id.toString() === property.value);

                        if (mainCards) {
                            this.setState({
                                reuseCard: mainCards[0].reuseCard
                            })
                        }
                    }
                });
            }
        );
    }

    public render(): React.ReactNode {
        const paymentPage: string = "outstandingPayment";

        if (this.props.multiProductPage) {

            return (
                <div className="inner-container">
                    <div className="banner dashboard-missed-payment-banner mb-0">
                        <div className="w-100">
                            <div className="overflow-auto">
                                <img src={`/${resourcesHelper.THEME}/img/alert-red.svg`} alt="Red alert icon"
                                     className="inline-warning-icon pt-2"/>
                                <div className="banner-text inline-warning-text">
                                    You have an outstanding balance of <span
                                    className="font-weight-bold">{getAmountToDisplay(this.props.amount)} </span>.
                                    <Link id="payNow"
                                          className="text-decoration-underline cursor-pointer text-blue-1 muli-bold-16"
                                          aria-label={"Pay Now"}
                                          state={{
                                              verifyCardFailed: false,
                                              product: this.props.product
                                          }}
                                          to={`/dashboard/account/${paymentPage}/${this.props.policyNumber}`}>
                                        Pay the balance</Link> or your policy will be cancelled
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="inner-container">
                    <div className="banner red-border">
                        <div className="w-100">
                            <div className="overflow-auto d-flex">
                                <div className="float-left">
                                    <img src={`/${resourcesHelper.THEME}/img/alert-blue.svg`} alt="Blue alert icon"
                                         className="inline-warning-icon"/>
                                </div>
                                <div className="banner-text inline-warning-text">
                                    You have an outstanding balance of <span
                                    className="font-weight-bold">{getAmountToDisplay(this.props.amount)} </span>.
                                </div>
                            </div>
                            <div className="px-3 my-3">
                                <Link id="payNow"
                                      className="btn btn-primary btn-next-no-arrow mt-0 mb-0 w-100 no-underline"
                                      state={{
                                          verifyCardFailed: false,
                                          product: this.props.product
                                      }}
                                      to={`/dashboard/account/${paymentPage}/${this.props.policyNumber}`}>
                                    Pay {getAmountToDisplay(this.props.amount)} now
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}
